import { Fragment } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { DialogContent, Dialog, Grid, Typography } from "@mui/material";
import { PrimaryButton } from "../../../css components/Button";

const Card = styled(Dialog)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export default function VerifyDialog({
  detail,
  setDetail,
  loginNavigation = false,
}) {
  const handleClose = () => {
    setDetail(false);
  };

  return (
    <Card open={detail} onClose={handleClose}>
      <DialogContent>
        <Grid container spacing={3} style={{ padding: "20px" }}>
          <Grid size={12} marginBottom={"10px"}>
            <Typography variant="h4">{detail}</Typography>
          </Grid>

          {loginNavigation && (
            <Fragment>
              <Grid size offset={{ md: "auto" }} />
              <Grid size>
                <Link to="/sign-in">
                  <PrimaryButton variant="contained" color="primary">
                    Go To Login
                  </PrimaryButton>
                </Link>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </DialogContent>
    </Card>
  );
}
